import shortid from "shortid";


export default function normalizeDestItems(destItems: any[]) {
  return destItems.map((d) => {
    let type = d?.optionableType;
    let option = d?.optionType;
    if (type === "financial") type = option.type;
    if (option) {
      const { title, name, nickName, personName } = option;
      option.title = title || name || nickName || personName;
    }
    return {
      ind: shortid.generate(),
      edit: false,
      data: {
        bank: type === "bank" ? option?.id : undefined,
        pos: type === "pos" ? option?.id : undefined,
        fund: type === "fund" ? option?.id : undefined,
        cashier: type === "cashier" ? option?.id : undefined,
        person: type === "person" ? option?.id : undefined,
        cheque: type === "cheque" ? option?.payment_id || option?.id : undefined,
        spendCheque: type === "spendCheque" ? option?.optionableId || option?.id : undefined,
        price: Math.abs(d?.amount),
        wage: d?.wage,
        ...(type === "cheque" && {
          branch: option?.branch,
          issuingBank: option?.bank,
          date: option?.dueDate,
          number: option?.number,
          sayad: option?.sayad || "",
        }),
        typeOption: option,
      },
      done: true,
      type: type,
      typeOption: option,
    };
  });
}
